import React from "react";
import { Navigate } from "react-router";
import { Link, NavLink } from "react-router-dom";
import Base from "./Base";

export class NavMenu extends Base {
    constructor(props) {
        super(props);
        this.state = {
            openMenu: "",
            menuOpen: 1,
            data: null,
            loading: true,
        };
    }
    async componentDidMount() {
        await this.getTranslates({ component: 'navmenu' });

        this.httpPost("api/v1/common/get").then((data) => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.setState({
                    data: data,
                    loading: false,
                });
            } else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false,
                });
            }
        });
    }
    render() {
        if (!this.isBlank(this.state.redirect))
            return <Navigate to={this.state.redirect} />;

        let contents = this.state.loading
            ? this.renderLoading()
            : this.renderForm();

        return contents;
    }
    toggleMenu(menu) {
        if (this.state.openMenu == menu) {
            if (this.state.openMenu.substr(0, 4) == "mgr_")
                this.setState({ openMenu: "mgr" });
            else this.setState({ openMenu: "" });
        } else this.setState({ openMenu: menu });
    }
    toggleMenu2() {
        if (this.state.menuOpen == 1) this.setState({ menuOpen: 0 });
        else this.setState({ menuOpen: 1 });
    }

    renderForm() {
        return (
            <div className={"nk-sidebar is-dark " + (this.state.menuOpen == 1 ? "" : "is-compact")} id="sideBarMenu" data-content="sidebarMenu">
                <div className="nk-sidebar-element nk-sidebar-head">
                    <div className="nk-menu-trigger" onClick={(e) => this.toggleMenu2()}>
                        <a className="nk-nav-toggle nk-quick-nav-icon d-xl-none" data-target="sidebarMenu">
                            <em className="icon ni ni-arrow-left"></em>
                        </a>
                        <a className="nk-nav-compact nk-quick-nav-icon d-none d-xl-inline-flex" data-target="sidebarMenu">
                            <em className="icon ni ni-menu"></em>
                        </a>
                        {this.state.menuOpen == 1111 && <Link to="/buy/modules/" className="btn btn-warning" style={{ "position": "absolute", "left": "18px", "top": "13px" }} >خرید و تمدید ماژول ها</Link>}
                    </div>
                </div>
                <div className="nk-sidebar-element nk-sidebar-body">
                    <div className="nk-sidebar-content">
                        <div className="nk-sidebar-menu" data-simplebar>
                            <ul className="nk-menu">
                                <li className="nk-menu-item">
                                    <Link to="/" className="nk-menu-link">
                                        <span className="nk-menu-icon">
                                            <em className="icon ni ni-home"></em>
                                        </span>
                                        <span className="nk-menu-text">داشبرد</span>
                                    </Link>
                                </li>
                                {this.state.data.global.user.role === 1 &&
                                    <li id="NavMenuLink_managment"
                                        class={ "nk-menu-item has-sub " +(this.state.openMenu == "mgr" || this.state.openMenu.substr(0, 3) == "mgr" ? "active" : "")}>
                                        <a className="hand nk-menu-link nk-menu-toggle"
                                            onClick={(e) => this.toggleMenu("mgr")}>
                                            <span className="nk-menu-icon">
                                                <em className="icon ni ni-grid-alt"></em>
                                            </span>
                                            <span className="nk-menu-text">مدیریتی</span>
                                            <span className="nk-menu-badge" id="navmenu_mgr" style={{ display: "none" }}>
                                                0
                                            </span>
                                        </a>
                                        <ul className="nk-menu-sub">
                                            <li className="nk-menu-item" id="NavMenuLink_users">
                                                <Link to="/users/" className="nk-menu-link">
                                                    <span className="nk-menu-text">کاربران</span>
                                                </Link>
                                            </li>
                                            <li className="nk-menu-item" id="NavMenuLink_userdrafts">
                                                <Link to="/userdocuments/" className="nk-menu-link">
                                                    <span className="nk-menu-text">تاییدیه مدارک</span>
                                                    <span className="nk-menu-badge" id="navmenu_mgr_userdocuments" style={{ display: "none" }}>
                                                        0
                                                    </span>
                                                </Link>
                                            </li>
                                            <li className="nk-menu-item" id="NavMenuLink_supports">
                                                <Link to="/supports/" className="nk-menu-link">
                                                    <span className="nk-menu-text">
                                                        پیام های پشتیبانی
                                                    </span>
                                                    <span
                                                        className="nk-menu-badge"
                                                        id="navmenu_mgr_tickets"
                                                        style={{ display: "none" }}
                                                    >
                                                        0
                                                    </span>
                                                </Link>
                                            </li>
                                            <li className="nk-menu-item" id="NavMenuLink_supports">
                                                <Link to="/campaigns/system/" className="nk-menu-link">
                                                    <span className="nk-menu-text">کمپین های تبلیغاتی</span>
                                                </Link>
                                            </li>
                                            
                                            <li id="NavMenuLink_basestuffs"
                                                class={"nk-menu-item " + (this.state.openMenu == "mgr_tax" ? "active" : "")} >
                                                <a
                                                    onClick={(e) => this.toggleMenu("mgr_tax")}
                                                    className="hand nk-menu-link nk-menu-toggle"
                                                >
                                                    <span className="nk-menu-text">سامانه مودیان</span>
                                                </a>
                                                <ul className="nk-menu-sub">
                                                    <li className="nk-menu-item">
                                                        <Link to="/basestuffs/" className="nk-menu-link">
                                                            <span className="nk-menu-text">
                                                                بانک کالا/خدمات
                                                            </span>
                                                        </Link>
                                                    </li>
                                                    <li className="nk-menu-item">
                                                        <Link
                                                            to="/system/headers/"
                                                            className="nk-menu-link"
                                                        >
                                                            <span className="nk-menu-text">
                                                                صورتحسابهای مودیان
                                                            </span>
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li id="NavMenuLink_finan" class={ "nk-menu-item " + (this.state.openMenu == "mgr_finance" ? "active" : "") } >
                                                <a
                                                    onClick={(e) => this.toggleMenu("mgr_finance")}
                                                    className="hand nk-menu-link nk-menu-toggle"
                                                >
                                                    <span className="nk-menu-text">امور مالی</span>
                                                </a>
                                                <ul className="nk-menu-sub">
                                                    <li className="nk-menu-item">
                                                        <Link to="/orderviews/" className="nk-menu-link">
                                                            <span className="nk-menu-text">فروش ها</span>
                                                        </Link>
                                                    </li>
                                                    <li className="nk-menu-item">
                                                        <Link to="/transactions/" className="nk-menu-link">
                                                            <span className="nk-menu-text">واریزی ها</span>
                                                        </Link>
                                                    </li>
                                                    <li className="nk-menu-item">
                                                        <Link to="/withdrawals/" className="nk-menu-link">
                                                            <span className="nk-menu-text">
                                                                درخواستهای برداشت
                                                            </span>
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li id="NavMenuLink_settings"
                                                class={
                                                    "nk-menu-item " +
                                                    (this.state.openMenu == "mgr_settings"
                                                        ? "active"
                                                        : "") } >
                                                <a onClick={(e) => this.toggleMenu("mgr_settings")}
                                                    className="hand nk-menu-link nk-menu-toggle">
                                                    <span className="nk-menu-text">تنظیمات</span>
                                                </a>
                                                <ul className="nk-menu-sub">
                                                    <li className="nk-menu-item">
                                                        <Link to="/affiliate/marketing/plans/" className="nk-menu-link">
                                                            <span className="nk-menu-text">
                                                                پلنهای همکاری در فروش
                                                            </span>
                                                        </Link>
                                                    </li>
                                                    <li className="nk-menu-item">
                                                        <Link to="/smstemplates/" className="nk-menu-link">
                                                            <span className="nk-menu-text">
                                                                الگوهای پیامکی
                                                            </span>
                                                        </Link>
                                                    </li>
                                                    <li className="nk-menu-item">
                                                        <Link to="/salarymonthsetting/" className="nk-menu-link">
                                                            <span className="nk-menu-text">ساعات موظفی</span>
                                                        </Link>
                                                    </li>
                                                    <li className="nk-menu-item">
                                                        <Link to="/escalation/" className="nk-menu-link">
                                                            <span className="nk-menu-text">
                                                                جدول تصاعدی حقوق
                                                            </span>
                                                        </Link>
                                                    </li>
                                                    <li className="nk-menu-item">
                                                        <Link to="/salarybase/" className="nk-menu-link">
                                                            <span className="nk-menu-text">
                                                                بخش نامه حقوق
                                                            </span>
                                                        </Link>
                                                    </li>
                                                    <li className="nk-menu-item">
                                                        <Link to="/systemmoduleprices/" className="nk-menu-link">
                                                            <span className="nk-menu-text">
                                                                قیمت گذاری ماژول ها
                                                            </span>
                                                        </Link>
                                                    </li>
                                                    {/*<li className="nk-menu-item">*/}
                                                    {/*    <Link to={"/company/edit/" + this.state.data.global.company.id + "/"} className="nk-menu-link">*/}
                                                    {/*        <span className="nk-menu-text">*/}
                                                    {/*            تنظیمات سامانه ها*/}
                                                    {/*        </span>*/}
                                                    {/*    </Link>*/}
                                                    {/*</li>*/}
                                                    {/*<li className="nk-menu-item">*/}
                                                    {/*    <Link to="/menues/" className="nk-menu-link">*/}
                                                    {/*        <span className="nk-menu-text">*/}
                                                    {/*            مدیریت منو ها*/}
                                                    {/*        </span>*/}
                                                    {/*    </Link>*/}
                                                    {/*</li>*/}
                                                    {/*<li className="nk-menu-item">*/}
                                                    {/*    <Link to="/actions/" className="nk-menu-link">*/}
                                                    {/*        <span className="nk-menu-text">*/}
                                                    {/*            مدیریت عملیات ها*/}
                                                    {/*        </span>*/}
                                                    {/*    </Link>*/}
                                                    {/*</li>*/}
                                                    <li className="nk-menu-item">
                                                        <Link to="/usergroups/" className="nk-menu-link">
                                                            <span className="nk-menu-text">
                                                                مدیریت گروه های کاربری
                                                            </span>
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </li>
                                }

                                {this.hasPermission(6) && <li id="NavMenuLink_6"
                                    class={"nk-menu-item has-sub " + (this.state.openMenu == "secretariat" ? "active" : "")}>
                                    <a className="hand nk-menu-link nk-menu-toggle" onClick={(e) => this.toggleMenu("secretariat")}>
                                        <span className="nk-menu-icon"><em className="icon ni ni-reports-alt"></em></span>
                                        <span className="nk-menu-text">اتوماسیون اداری</span>
                                    </a>
                                    <ul className="nk-menu-sub">
                                        {this.hasPermission(61) && <li className="nk-menu-item" id="NavMenuLink_61">
                                            <Link to="/letters/my/" className="nk-menu-link">
                                                <span className="nk-menu-text">کارتابل من</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(62) && <li className="nk-menu-item" id="NavMenuLink_62">
                                            <Link to="/letters/internal" className="nk-menu-link">
                                                <span className="nk-menu-text">نامه های داخلی</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(63) && <li className="nk-menu-item" id="NavMenuLink_63">
                                            <Link to="/letters/out" className="nk-menu-link">
                                                <span className="nk-menu-text">نامه های صادره</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(64) && <li className="nk-menu-item" id="NavMenuLink_64">
                                            <Link to="/letters/in" className="nk-menu-link">
                                                <span className="nk-menu-text">نامه های وارده</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(111) && <li className="nk-menu-item" id="NavMenuLink_111">
                                            <Link to="/letters/all" className="nk-menu-link">
                                                <span className="nk-menu-text">کلیه نامه ها</span>
                                            </Link>
                                        </li>}
                                        {this.state.data.global.letterFolders.map(letter => <li className="nk-menu-item">
                                            <Link to={"/letters/my/" + letter.id + "/"} className="nk-menu-link">
                                                <span className="nk-menu-text">{letter.title}</span>
                                            </Link>
                                        </li>)}
                                        {this.hasPermission(105) && <li className="nk-menu-item" id="NavMenuLink_105">
                                            <Link to="/bulletins/" className="nk-menu-link">
                                                <span className="nk-menu-text">بولتن اطلاع رسانی</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(106) && <li className="nk-menu-item" id="NavMenuLink_106">
                                            <Link to="/leaves/" className="nk-menu-link">
                                                <span className="nk-menu-text">درخواست مرخصی</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(199) && <li className="nk-menu-item" id="NavMenuLink_199">
                                            <Link className="nk-menu-link" to="/forms/1/">
                                                <span className="nk-menu-text">درخواست اضافه کاری</span>
                                            </Link>
                                        </li>}
                                            {this.hasPermission(200) && <li className="nk-menu-item" id="NavMenuLink_200">
                                            <Link className="nk-menu-link" to="/forms/2/">
                                                <span className="nk-menu-text">درخواست ماموریت</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(201) && <li className="nk-menu-item" id="NavMenuLink_201">
                                            <Link className="nk-menu-link" to="/forms/3/">
                                                <span className="nk-menu-text">درخواست مساعده حقوق</span>
                                            </Link>
                                        </li>}
                                    </ul>
                                </li>}
                                {this.hasPermission(1) && <li id="NavMenuLink_1" class={"nk-menu-item has-sub " + (this.state.openMenu == "base" ? "active" : "")}>
                                    <a className="hand nk-menu-link nk-menu-toggle" onClick={e => this.toggleMenu('base')}>
                                        <span className="nk-menu-icon"><em className="icon ni ni-building"></em></span>
                                        <span className="nk-menu-text">اطلاعات پایه</span>
                                    </a>
                                    <ul className="nk-menu-sub">
                                        <li className="nk-menu-heading">
                                            <h6 className="overline-title text-primary-alt"></h6>
                                        </li>
                                        {!this.isNull(this.state.data.global.company) && this.hasPermission(92) && <li className="nk-menu-item" id="NavMenuLink_92">
                                            <Link to={"/company/edit/" + this.state.data.global.company.id + "/"} className="nk-menu-link">
                                                <span className="nk-menu-text">تنظیمات کسب و کار</span>
                                            </Link>
                                        </li>}
                                        {!this.isNull(this.state.data.global.company) && this.hasPermission(14) && <li className="nk-menu-item" id="NavMenuLink_14">
                                            <Link to="/company/users/" className="nk-menu-link">
                                                <span className="nk-menu-text">کاربران کسب و کار</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(15) && <li className="nk-menu-item" id="NavMenuLink_15">
                                            <Link to="/annuals/" className="nk-menu-link">
                                                <span className="nk-menu-text">سال های مالی</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(16) && <li className="nk-menu-item" id="NavMenuLink_16">
                                            <Link to="/accounts/" className="nk-menu-link">
                                                <span className="nk-menu-text">کدینگ حسابها</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(188) && <li className="nk-menu-item" id="NavMenuLink_16">
                                            <Link to="/accounts/mapping/" className="nk-menu-link">
                                                <span className="nk-menu-text">حسابهای پیش فرض</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(115) && <li className="nk-menu-item" id="NavMenuLink_115">
                                            <Link to="/todo/" className="nk-menu-link">
                                                <span className="nk-menu-text">یادداشتها</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(17) && <li className="nk-menu-item" id="NavMenuLink_17">
                                            <Link to="/stuffs/" className="nk-menu-link">
                                                <span className="nk-menu-text">کالاها/خدمات</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(216) && <li className="nk-menu-item" id="NavMenuLink_17">
                                            <Link to="/priceannouncements/" className="nk-menu-link">
                                                <span className="nk-menu-text">اعلامیه های قیمتی</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(18) && <li className="nk-menu-item" id="NavMenuLink_18">
                                            <Link to="/persons/" className="nk-menu-link">
                                                <span className="nk-menu-text">اشخاص و شرکتها</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(107) && <li className="nk-menu-item" id="NavMenuLink_107">
                                            <Link to="/customers/" className="nk-menu-link">
                                                <span className="nk-menu-text">مشتریان و شرکتها</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(108) && <li className="nk-menu-item" id="NavMenuLink_108">
                                            <Link to="/staffs/" className="nk-menu-link">
                                                <span className="nk-menu-text">کارمندان</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(19) && <li className="nk-menu-item" id="NavMenuLink_19">
                                            <Link to="/warehouses/" className="nk-menu-link">
                                                <span className="nk-menu-text">انبارهای کالا</span>
                                            </Link>
                                        </li>}                                        
                                        {this.hasPermission(198) && <li className="nk-menu-item" id="NavMenuLink_198">
                                            <Link to="/banks/" className="nk-menu-link">
                                                <span className="nk-menu-text">بانکها</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(20) && <li className="nk-menu-item" id="NavMenuLink_20">
                                            <Link to="/bankaccounts/" className="nk-menu-link">
                                                <span className="nk-menu-text">حسابهای بانکی</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(202) && <li className="nk-menu-item" id="NavMenuLink_20">
                                            <Link to="/chequeprinttemplates/" className="nk-menu-link">
                                                <span className="nk-menu-text">الگوهای چاپ دسته چک</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(21) && <li className="nk-menu-item" id="NavMenuLink_21">
                                            <Link to="/cashdesks/" className="nk-menu-link">
                                                <span className="nk-menu-text">صندوق ها</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(22) && <li className="nk-menu-item" id="NavMenuLink_22">
                                            <Link to="/tafsils/" className="nk-menu-link">
                                                <span className="nk-menu-text">حساب های تفصیلی</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(23) && <li className="nk-menu-item" id="NavMenuLink_23">
                                            <Link to="/branches/" className="nk-menu-link">
                                                <span className="nk-menu-text">شعب</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(24) && <li className="nk-menu-item" id="NavMenuLink_24">
                                            <Link to="/currencies/" className="nk-menu-link">
                                                <span className="nk-menu-text">واحدهای پولی</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(25) && <li className="nk-menu-item" id="NavMenuLink_25">
                                            <Link to="/company/smstemplates/" className="nk-menu-link">
                                                <span className="nk-menu-text">الگوهای پیامکی</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(26) && <li className="nk-menu-item" id="NavMenuLink_26">
                                            <Link to="/orgunits/" className="nk-menu-link">
                                                <span className="nk-menu-text">واحدهای سازمانی</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(27) && <li className="nk-menu-item" id="NavMenuLink_27">
                                            <Link to="/orgposts/" className="nk-menu-link">
                                                <span className="nk-menu-text">پستهای سازمانی</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(28) && <li className="nk-menu-item" id="NavMenuLink_28">
                                            <Link to="/organworkinggroups/" className="nk-menu-link">
                                                <span className="nk-menu-text">کارگروه ها</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(29) && <li className="nk-menu-item" id="NavMenuLink_29">
                                            <Link to="/organchart/" className="nk-menu-link">
                                                <span className="nk-menu-text">چارت سازمانی</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(30) && <li className="nk-menu-item" id="NavMenuLink_30">
                                            <Link to="/andikators/" className="nk-menu-link">
                                                <span className="nk-menu-text">اندیکاتورها</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(93) && <li className="nk-menu-item" id="NavMenuLink_93">
                                            <Link to="/usergroups/" className="nk-menu-link">
                                                <span className="nk-menu-text">گروه های کاربری</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(102) && <li className="nk-menu-item" id="NavMenuLink_102">
                                            <Link to="/productionlines/" className="nk-menu-link">
                                                <span className="nk-menu-text">خطوط تولید</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(114) && <li className="nk-menu-item" id="NavMenuLink_114">
                                            <Link to="/api/" className="nk-menu-link">
                                                <span className="nk-menu-text">توکن های دسترسی API</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(121) && <li className="nk-menu-item" id="NavMenuLink_121">
                                            <Link to="/restaurant/tables/" className="nk-menu-link">
                                                <span className="nk-menu-text">میزها</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(129) && <li className="nk-menu-item" id="NavMenuLink_129">
                                            <Link to="/restaurant/menu/" className="nk-menu-link">
                                                <span className="nk-menu-text">تنظیمات منو</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(123) && <li className="nk-menu-item" id="NavMenuLink_123">
                                            <Link to="/club/levels/" className="nk-menu-link">
                                                <span className="nk-menu-text">سطوح باشگاه مشتریان</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(124) && <li className="nk-menu-item" id="NavMenuLink_124">
                                            <Link to="/club/rewards/" className="nk-menu-link">
                                                <span className="nk-menu-text">پاداش های باشگاه مشتریان</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(221) && <li className="nk-menu-item" id="NavMenuLink_221">
                                            <Link to="/bpms/workflows/" className="nk-menu-link">
                                                <span className="nk-menu-text">فرآیندهای کسب و کار</span>
                                            </Link>
                                        </li>}
                                    </ul>
                                </li>}
                                {this.hasPermission(2) && <li id="NavMenuLink_2" class={"nk-menu-item has-sub " + (this.state.openMenu == "acc" ? "active" : "")}>
                                    <a className="hand nk-menu-link nk-menu-toggle" onClick={e => this.toggleMenu('acc')}>
                                        <span className="nk-menu-icon"><em className="icon ni ni-file-docs"></em></span>
                                        <span className="nk-menu-text">میزکار حسابداری</span>
                                    </a>
                                    <ul className="nk-menu-sub">
                                        {this.hasPermission(31) && <Link to="/ordering/" className="nk-menu-link">
                                            <span className="nk-menu-text">سفارشات فروش</span>
                                        </Link>}
                                        {this.hasPermission(32) && <Link to="/invoices/" className="nk-menu-link">
                                            <span className="nk-menu-text">صورتحسابهای فروش مودیان</span>
                                        </Link>}
                                        {this.hasPermission(33) && <Link to="/myinvoices/" className="nk-menu-link">
                                            <span className="nk-menu-text">صورتحسابهای خرید مودیان</span>
                                        </Link>}
                                        {this.hasPermission(34) && <Link to="/factors/buy/" className="nk-menu-link">
                                            <span className="nk-menu-text">فاکتورهای خرید داخلی</span>
                                        </Link>}
                                        {this.hasPermission(218) && <Link to="/factors/buy/service/" className="nk-menu-link">
                                            <span className="nk-menu-text">فاکتورهای خرید خدمات</span>
                                        </Link>}
                                        {this.hasPermission(35) && <Link to="/factors/sale/" className="nk-menu-link">
                                            <span className="nk-menu-text">فاکتورهای فروش</span>
                                        </Link>}
                                        {this.hasPermission(219) && <Link to="/factors/sale/service/" className="nk-menu-link">
                                            <span className="nk-menu-text">فاکتورهای فروش خدمات</span>
                                        </Link>}
                                        {this.hasPermission(36) && <Link to="/factors/buyreturn/" className="nk-menu-link">
                                            <span className="nk-menu-text">فاکتورهای برگشت از خرید</span>
                                        </Link>}
                                        {this.hasPermission(37) && <Link to="/factors/salereturn/" className="nk-menu-link">
                                            <span className="nk-menu-text">فاکتورهای برگشت از فروش</span>
                                        </Link>}
                                        {this.hasPermission(38) && <Link to="/factors/waste/" className="nk-menu-link">
                                            <span className="nk-menu-text">فاکتورهای ضایعات</span>
                                        </Link>}
                                        {this.hasPermission(39) && <Link to="/documents/" className="nk-menu-link">
                                            <span className="nk-menu-text">اسناد حسابداری</span>
                                        </Link>}
                                        {this.hasPermission(40) && <Link to="/referencedocuments/" className="nk-menu-link">
                                            <span className="nk-menu-text">اسناد حسابداری مرجع</span>
                                        </Link>}
                                        {this.hasPermission(45) && <Link to="/salaries/" className="nk-menu-link">
                                            <span className="nk-menu-text">مدیریت تنخواه</span>
                                        </Link>}
                                        {this.hasPermission(116) && <Link to="/installments/" className="nk-menu-link">
                                            <span className="nk-menu-text">فروش اقساطی</span>
                                        </Link>}
                                        {this.hasPermission(122) && <li className="nk-menu-item">
                                            <Link to="/orderings/buy/" className="nk-menu-link">
                                                <span className="nk-menu-text">سفارشات خرید</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(112) && 1 === 2 && <Link to="/annual/close/" className="nk-menu-link">
                                            <span className="nk-menu-text">عملیات پایان دوره</span>
                                        </Link>}
                                        {this.hasPermission(214) && <Link className="nk-menu-link" to="/fullprices">بهای تمام شده</Link>}
                                    </ul>
                                </li>}

                                {this.hasPermission(222) && <li id="NavMenuLink_2" class={"nk-menu-item has-sub " + (this.state.openMenu == "khazane" ? "active" : "")}>
                                    <a className="hand nk-menu-link nk-menu-toggle" onClick={e => this.toggleMenu('khazane')}>
                                        <span className="nk-menu-icon"><em className="icon ni ni-file-docs"></em></span>
                                        <span className="nk-menu-text">خزانه</span>
                                    </a>
                                    <ul className="nk-menu-sub">
                                        {this.hasPermission(41) && <Link to="/receipts/in/" className="nk-menu-link">
                                            <span className="nk-menu-text">دریافتها</span>
                                        </Link>}
                                        {this.hasPermission(42) && <Link to="/receipts/out/" className="nk-menu-link">
                                            <span className="nk-menu-text">پرداختها</span>
                                        </Link>}
                                        {this.hasPermission(210) && <Link to="/receipts/in/book/" className="nk-menu-link">دفتر دریافتها</Link>}
                                        {this.hasPermission(215) && <Link to="/receipts/transfer/" className="nk-menu-link">انتقال وجه</Link>}
                                        {this.hasPermission(43) && <Link to="/cheques/in/" className="nk-menu-link">
                                            <span className="nk-menu-text">چکهای دریافتی</span>
                                        </Link>}
                                        {this.hasPermission(44) && <Link to="/cheques/out/" className="nk-menu-link">
                                            <span className="nk-menu-text">چکهای پرداختی</span>
                                        </Link>}
                                    </ul>
                                </li>}

                                {this.hasPermission(223) && <li id="NavMenuLink_2" class={"nk-menu-item has-sub " + (this.state.openMenu == "bazargani" ? "active" : "")}>
                                    <a className="hand nk-menu-link nk-menu-toggle" onClick={e => this.toggleMenu('bazargani')}>
                                        <span className="nk-menu-icon"><em className="icon ni ni-file-docs"></em></span>
                                        <span className="nk-menu-text">بازرگانی</span>
                                    </a>
                                    <ul className="nk-menu-sub">
                                        {this.hasPermission(220) && <li className="nk-menu-item">
                                            <Link to="/orderings/buy/foreign/" className="nk-menu-link">
                                                <span className="nk-menu-text">سفارشات خرید خارجی</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(34) && <Link to="/factors/buy/foreign/" className="nk-menu-link">
                                            <span className="nk-menu-text">فاکتورهای خرید خارجی</span>
                                        </Link>}
                                        {this.hasPermission(211) && <Link className="nk-menu-link" to="/billofladings">بارنامه ها</Link>}
                                        {this.hasPermission(212) && <Link className="nk-menu-link" to="/customsclearances">ترخیص کالاها</Link>}
                                        {this.hasPermission(213) && <Link className="nk-menu-link" to="/insurancepolicies">بیمه نامه ها</Link>}
                                    </ul>
                                </li>}
                                {this.hasPermission(3) && <li id="NavMenuLink_3" class={"nk-menu-item has-sub " + (this.state.openMenu == "warehouse" ? "active" : "")}>
                                    <a className="hand nk-menu-link nk-menu-toggle" onClick={e => this.toggleMenu('warehouse')}>
                                        <span className="nk-menu-icon"><em className="icon ni ni-file-docs"></em></span>
                                        <span className="nk-menu-text">{this.T('menu.warehouse')}</span>
                                    </a>
                                    <ul className="nk-menu-sub">
                                        {this.hasPermission(46) && <Link to="/ordering/review/" className="nk-menu-link">
                                            <span className="nk-menu-text">رسیدگی سفارشات</span>
                                        </Link>}
                                        {this.hasPermission(47) && <Link to="/remittances/in/" className="nk-menu-link">
                                            <span className="nk-menu-text">رسیدهای انبار</span>
                                        </Link>}
                                        {this.hasPermission(48) && <Link to="/remittances/out/" className="nk-menu-link">
                                            <span className="nk-menu-text">حواله های انبار</span>
                                        </Link>}
                                        {this.hasPermission(49) && <Link to="/remittances/transfer/" className="nk-menu-link">
                                            <span className="nk-menu-text">جابجایی کالاها</span>
                                        </Link>}
                                        {this.hasPermission(50) && <Link to="/stuff/cardex/" className="nk-menu-link">
                                            <span className="nk-menu-text">کاردکس کالاها</span>
                                        </Link>}
                                        {this.hasPermission(51) && <Link to="/stuff/inventory/turnover/" className="nk-menu-link">
                                            <span className="nk-menu-text">گردش موجودی</span>
                                        </Link>}
                                        {this.hasPermission(110) && <Link to="/report/sale/stuffs" className="nk-menu-link">
                                            <span className="nk-menu-text">گزارش فروش کالاها</span>
                                        </Link>}
                                        {this.hasPermission(187) && <Link to="/report/sale/stuffs/detail" className="nk-menu-link">
                                            <span className="nk-menu-text">گزارش جزئیات فروش کالاها</span>
                                        </Link>}
                                        {this.hasPermission(190) && <Link className="nk-menu-link" to="/supplies/internal">
                                            <span className="nk-menu-text">درخواستهای کالا</span>
                                        </Link>}
                                        {this.hasPermission(191) && <Link className="nk-menu-link" to="/supplies/orders">
                                            <span className="nk-menu-text">سفارشات خرید</span>
                                        </Link>}
                                        {this.hasPermission(217) && <Link className="nk-menu-link" to="/stocktakings">
                                            <span className="nk-menu-text">انبارگردانی</span>
                                        </Link>}
                                    </ul>
                                </li>}
                                {(this.hasPermission(4) || !this.isEmpty(this.state.data.global.reports)) && <li id="NavMenuLink_4" className={ "nk-menu-item has-sub " + (this.state.openMenu == "reports" ? "active" : "") } >
                                    <a className="hand nk-menu-link nk-menu-toggle" onClick={(e) => this.toggleMenu("reports")}>
                                        <span className="nk-menu-icon">
                                            <em className="icon ni ni-file-docs"></em>
                                        </span>
                                        <span className="nk-menu-text">گزارشات</span>
                                    </a>
                                    <ul className="nk-menu-sub">
                                        {this.hasPermission(52) && <Link to="/report/ledger/" className="nk-menu-link">
                                            <span className="nk-menu-text">دفتر معین،کل</span>
                                        </Link>}
                                        {this.hasPermission(53) && <Link to="/report/journal/" className="nk-menu-link">
                                            <span className="nk-menu-text">دفتر روزنامه</span>
                                        </Link>}
                                        {this.hasPermission(54) && <Link to="/report/balance/" className="nk-menu-link">
                                            <span className="nk-menu-text">ترازنامه</span>
                                        </Link>}
                                        {this.hasPermission(55) && <Link to="/report/trialbalance/" className="nk-menu-link">
                                            <span className="nk-menu-text">ترازآزمایشی</span>
                                        </Link>}
                                        {this.hasPermission(227) && <Link to="/report/income/" className="nk-menu-link">
                                            <span className="nk-menu-text">صورت سود و زیان</span>
                                        </Link>}
                                        {this.hasPermission(56) && <Link to="/report/debcred" className="nk-menu-link">
                                            <span className="nk-menu-text">
                                                بدهکاران / بستانکاران
                                            </span>
                                        </Link>}
                                        {this.hasPermission(57) && <Link to="/report/explore/" className="nk-menu-link">
                                            <span className="nk-menu-text">مرور حسابها</span>
                                        </Link>}
                                        {this.hasPermission(125) && <Link to="/report/transactions/" className="nk-menu-link">
                                            <span className="nk-menu-text">گردش حسابها</span>
                                        </Link>}
                                        {this.hasPermission(203) && <Link to="/userlogs/" className="nk-menu-link">
                                            <span className="nk-menu-text">فعالیت کاربران</span>
                                        </Link>}
                                        {this.hasPermission(58) && <Link to="/report/banktransaction/" className="nk-menu-link">
                                            <span className="nk-menu-text">گردش حساب بانک</span>
                                        </Link>}
                                        {this.hasPermission(59) && <Link
                                            to="/report/cashtransaction/"
                                            className="nk-menu-link"
                                        >
                                            <span className="nk-menu-text">گردش حساب صندوق</span>
                                        </Link>}
                                        {this.hasPermission(60) && <Link to="/report/others" className="nk-menu-link">
                                            <span className="nk-menu-text">گزارش های ممیز مالیاتی</span>
                                        </Link>}
                                        {this.hasPermission(113) && <Link to="/production/trackings/" className="nk-menu-link">
                                            <span className="nk-menu-text">گزارش ردیابی</span>
                                        </Link>}
                                        {this.hasPermission(193) && <Link to="/production/trackings2/" className="nk-menu-link">
                                            <span className="nk-menu-text">آمار کشت</span>
                                        </Link>}
                                        {this.hasPermission(109) && <Link to="/reports/" className="nk-menu-link">
                                            <span className="nk-menu-text">گزارش ساز پیشرفته</span>
                                        </Link>}
                                        {this.state.data.global.reports.map(report => <Link to={"/reports/view/" + report.id + "/"} className="nk-menu-link">
                                            <span className="nk-menu-text">{report.title}</span>
                                        </Link>)}
                                    </ul>
                                </li>}
                                {this.hasPermission(5) && <li id="NavMenuLink_5"
                                    class={"nk-menu-item has-sub " + (this.state.openMenu == "contracts" ? "active" : "")}>
                                    <a className="hand nk-menu-link nk-menu-toggle" onClick={(e) => this.toggleMenu("contracts")}>
                                        <span className="nk-menu-icon"><em className="icon ni ni-reports-alt"></em></span>
                                        <span className="nk-menu-text">مدیریت قراردادها</span>
                                    </a>
                                    <ul className="nk-menu-sub">
                                        {this.hasPermission(90) && <li className="nk-menu-item">
                                            <Link to="/contracts/" className="nk-menu-link">
                                                <span className="nk-menu-text">قراردادها</span>
                                            </Link>
                                        </li>}
                                    </ul>
                                </li>}
                                {this.hasPermission(7) && <li id="NavMenuLink_7" class={"nk-menu-item has-sub " + (this.state.openMenu == "hrm" ? "active" : "")}>
                                    <a className="hand nk-menu-link nk-menu-toggle" onClick={e => this.toggleMenu('hrm')}>
                                        <span className="nk-menu-icon"><em className="icon ni ni-file-docs"></em></span>
                                        <span className="nk-menu-text">میزکار حقوق و دستمزد</span>
                                    </a>
                                    <ul className="nk-menu-sub">
                                        {this.hasPermission(65) && <li className="nk-menu-item">
                                            <Link to="/timesheets/my/" className="nk-menu-link">
                                                <span className="nk-menu-text">گزارش کارکرد من</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(66) && <li className="nk-menu-item">
                                            <Link to="/timesheets/report/" className="nk-menu-link">
                                                <span className="nk-menu-text">گزارش کارکرد کارکنان</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(67) && <li className="nk-menu-item">
                                            <Link to="/contracts/my/" className="nk-menu-link">
                                                <span className="nk-menu-text">قراردادهای من</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(68) && <li className="nk-menu-item">
                                            <Link to="/employmentorders/my/" className="nk-menu-link">
                                                <span className="nk-menu-text">احکام کارگزینی من</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(69) && <li className="nk-menu-item">
                                            <Link to="/payslips/my/" className="nk-menu-link">
                                                <span className="nk-menu-text">فیش های حقوقی من</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(70) && <li className="nk-menu-item">
                                            <Link to="/employmentorders/" className="nk-menu-link">
                                                <span className="nk-menu-text">احکام کارگزینی</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(71) && <li className="nk-menu-item">
                                            <Link to="/timesheets/" className="nk-menu-link">
                                                <span className="nk-menu-text">تایم شیت</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(72) && <li className="nk-menu-item">
                                            <Link to="/payslips/" className="nk-menu-link">
                                                <span className="nk-menu-text">فیش های حقوقی</span>
                                            </Link>
                                        </li>}
                                        {this.hasPermission(73) && <li className="nk-menu-item">
                                            <Link to="/payslips/excel/" className="nk-menu-link">
                                                <span className="nk-menu-text">اکسل لیست کارکنان</span>
                                            </Link>
                                        </li>}
                                    </ul>
                                </li>}
                                {this.hasPermission(103) && <li id="NavMenuLink_103" className={"nk-menu-item has-sub " + (this.state.openMenu == "production" ? "active" : "")} >
                                    <a className="hand nk-menu-link nk-menu-toggle" onClick={(e) => this.toggleMenu("production")} >
                                        <span className="nk-menu-icon">
                                            <em className="icon ni ni-box"></em>
                                        </span>
                                        <span className="nk-menu-text">
                                            مدیریت تولید
                                        </span>
                                    </a>
                                    <ul className="nk-menu-sub">
                                        {this.hasPermission(192) && <Link to="/orders/analize/" className="nk-menu-link">
                                            <span className="nk-menu-text">برآورد سفارشات</span>
                                        </Link>}
                                        {this.hasPermission(79) && <Link to="/production/orders/" className="nk-menu-link">
                                            <span className="nk-menu-text">سفارشات تولید</span>
                                        </Link>}
                                        {this.hasPermission(117) && <Link to="/production/planing/" className="nk-menu-link">
                                            <span className="nk-menu-text">برنامه ریزی تولید</span>
                                        </Link>}
                                        {this.hasPermission(195) && <Link to="/production/list/" className="nk-menu-link">
                                            <span className="nk-menu-text">تولید محصولی-مرحله ای</span>
                                        </Link>}
                                        {this.hasPermission(104) && <Link to="/production/calendar/" className="nk-menu-link">
                                            <span className="nk-menu-text">تقویم تولید</span>
                                        </Link>}
                                    </ul>
                                </li>}
                                {this.hasPermission(118) && <li id="NavMenuLink_118" className={"nk-menu-item has-sub " + (this.state.openMenu == "contractor" ? "active" : "")} >
                                    <a className="hand nk-menu-link nk-menu-toggle" onClick={(e) => this.toggleMenu("contractor")} >
                                        <span className="nk-menu-icon">
                                            <em className="icon ni ni-task"></em>
                                        </span>
                                        <span className="nk-menu-text">
                                            پیمانکاری
                                        </span>
                                    </a>
                                    <ul className="nk-menu-sub">
                                        {this.hasPermission(119) && <Link to="/contracting/contracts/" className="nk-menu-link">
                                            <span className="nk-menu-text">قراردادها</span>
                                        </Link>}
                                        {this.hasPermission(120) && <Link to="/contracting/progressclaims/" className="nk-menu-link">
                                            <span className="nk-menu-text">صورت وضعیتها</span>
                                        </Link>}
                                    </ul>
                                </li>}
                                {this.hasPermission(11) && <li id="NavMenuLink_11"
                                    className={
                                        "nk-menu-item has-sub " +
                                        (this.state.openMenu == "crm" ? "active" : "")
                                    }
                                >
                                    <a className="hand nk-menu-link nk-menu-toggle" onClick={(e) => this.toggleMenu("crm")}>
                                        <span className="nk-menu-icon">
                                            <em className="icon ni ni-users"></em>
                                        </span>
                                        <span className="nk-menu-text">
                                            مدیریت ارتباط با مشتریان
                                        </span>
                                    </a>
                                    <ul className="nk-menu-sub">
                                        {this.hasPermission(74) && <Link to="/crm/teams/" className="nk-menu-link">
                                            <span className="nk-menu-text">تیم/پیگیری ها</span>
                                        </Link>}
                                        {this.hasPermission(75) && <Link to="/crm/cases/archived" className="nk-menu-link">
                                            <span className="nk-menu-text">بایگانی پیگیری ها</span>
                                        </Link>}
                                        {this.hasPermission(76) && <Link to="/crm/cases/blacklist" className="nk-menu-link">
                                            <span className="nk-menu-text">بلک لیست پیگیری ها</span>
                                        </Link>}
                                        {this.hasPermission(77) && <Link to="/crm/ordering/" className="nk-menu-link">
                                            <span className="nk-menu-text">سفارشات فروش</span>
                                        </Link>}
                                        {this.hasPermission(80) && <Link to="/proformainvoice/" className="nk-menu-link">
                                            <span className="nk-menu-text">پیش فاکتورها</span>
                                        </Link>}
                                        {this.hasPermission(81) && <Link to="/meetings/my/" className="nk-menu-link">
                                            <span className="nk-menu-text">
                                                جلسات من
                                            </span>
                                        </Link>}
                                        {this.hasPermission(82) && <Link to="/meetings/" className="nk-menu-link">
                                            <span className="nk-menu-text">
                                                مدیریت جلسات
                                            </span>
                                        </Link>}
                                        {this.hasPermission(83) && <Link to="/campaigns/companies/" className="nk-menu-link">
                                            <span className="nk-menu-text">کمپین های تبلیغاتی</span>
                                        </Link>
                                        }
                                    </ul>
                                </li>}
                                {this.hasPermission(12) && <li id="NavMenuLink_12"
                                    className={
                                        "nk-menu-item has-sub " +
                                        (this.state.openMenu == "solution" ? "active" : "")
                                    }
                                >
                                    <a className="hand nk-menu-link nk-menu-toggle"
                                        onClick={(e) => this.toggleMenu("solution")}>
                                        <span className="nk-menu-icon">
                                            <em className="icon ni ni-file-docs"></em>
                                        </span>
                                        <span className="nk-menu-text">میزکار مدیریت پروژه</span>
                                    </a>
                                    <ul className="nk-menu-sub">
                                        {this.hasPermission(84) && <Link to="/solutions/" className="nk-menu-link">
                                            <span className="nk-menu-text">پروژه ها</span>
                                        </Link>}
                                        {this.hasPermission(85) && <Link to="/solution/my/tasks/" className="nk-menu-link">
                                            <span className="nk-menu-text">وظایف من</span>
                                        </Link>}
                                    </ul>
                                </li>}
                                {this.hasPermission(13) && <li id="NavMenuLink_13"
                                    className={
                                        "nk-menu-item has-sub " +
                                        (this.state.openMenu == "buildings" ? "active" : "")
                                    }
                                >
                                    <a
                                        className="hand nk-menu-link nk-menu-toggle"
                                        onClick={(e) => this.toggleMenu("buildings")}
                                    >
                                        <span className="nk-menu-icon">
                                            <em className="icon ni ni-building"></em>
                                        </span>
                                        <span className="nk-menu-text">میزکار مدیریت ساختمان</span>
                                    </a>
                                    <ul className="nk-menu-sub">
                                        {this.hasPermission(86) && <Link to="/buildings/" className="nk-menu-link">
                                            <span className="nk-menu-text">مدیریت ساختمان</span>
                                        </Link>}
                                        {this.hasPermission(87) && <Link to="/building/bills/all/" className="nk-menu-link">
                                            <span className="nk-menu-text">صورتحساب کلیه واحدها</span>
                                        </Link>}
                                        {this.hasPermission(88) && <Link to="/building/bills/my/" className="nk-menu-link">
                                            <span className="nk-menu-text">صورتحسابهای من</span>
                                        </Link>}
                                        {this.hasPermission(94) && <Link to="/building/bills/aggregated/all/" className="nk-menu-link">
                                            <span className="nk-menu-text">گزارش تجمیعی واحدها</span>
                                        </Link>}
                                        {this.hasPermission(95) && <Link to="/building/bills/aggregated/my/" className="nk-menu-link">
                                            <span className="nk-menu-text">گزارش تجمیعی من</span>
                                        </Link>}                                
                                        {this.hasPermission(89) && <Link to="/building/receipts/my/" className="nk-menu-link">
                                            <span className="nk-menu-text">پرداختهای من</span>
                                        </Link>}
                                    </ul>
                                </li>}
                                {this.hasPermission(10) && <li id="NavMenuLink_10"
                                    class={"nk-menu-item has-sub " + (this.state.openMenu == "estates" ? "active" : "")}>
                                    <a className="hand nk-menu-link nk-menu-toggle" onClick={(e) => this.toggleMenu("estates")}>
                                        <span className="nk-menu-icon"><em className="icon ni ni-reports-alt"></em></span>
                                        <span className="nk-menu-text">میزکار مدیریت اموال</span>
                                    </a>
                                    <ul className="nk-menu-sub">
                                        {this.hasPermission(91) && <li className="nk-menu-item">
                                            <Link to="/estates/" className="nk-menu-link">
                                                <span className="nk-menu-text">اموال</span>
                                            </Link>
                                        </li>}
                                    </ul>
                                </li>}
                                {this.state.data.global.user.role === 1 && (
                                    <li id="NavMenuLink_fm" className="nk-menu-item">
                                        <NavLink to="/fm/" className="nk-menu-link">
                                            <span className="nk-menu-icon">
                                                <em className="icon ni ni-files"></em>
                                            </span>
                                            <span className="nk-menu-text">مدیریت فایل</span>
                                        </NavLink>
                                    </li>
                                )}
                                {1 === 2 && <li id="NavMenuToolsMenu" class={"nk-menu-item has-sub " + (this.state.openMenu == "tools" ? "active" : "")}>
                                    <a className="hand nk-menu-link nk-menu-toggle" onClick={(e) => this.toggleMenu("tools")}>
                                        <span className="nk-menu-icon">
                                            <em className="icon fa fa-list"></em>
                                        </span>
                                        <span className="nk-menu-text">ابزارها</span>
                                    </a>
                                    <ul className="nk-menu-sub">
                                        <li className="nk-menu-item">
                                            <Link to="/mydocuments/" className="nk-menu-link">
                                                <span className="nk-menu-text">مدارک من</span>
                                            </Link>
                                        </li>
                                        <li className="nk-menu-item">
                                            <Link to="/referral/" className="nk-menu-link">
                                                <span className="nk-menu-text">
                                                    دوستان/زیرمجموعه ها
                                                </span>
                                            </Link>
                                        </li>
                                        <li className="nk-menu-item">
                                            <Link to="/affiliate/" className="nk-menu-link">
                                                <span className="nk-menu-text">
                                                    همکاری در فروش
                                                </span>
                                            </Link>
                                        </li>
                                        <li className="nk-menu-item">
                                            <Link to="/mywallet/" className="nk-menu-link">
                                                <span className="nk-menu-text">کیف پول من</span>
                                            </Link>
                                        </li>
                                        <li className="nk-menu-item">
                                            <Link to="/tickets/" className="nk-menu-link">
                                                <span className="nk-menu-text">پیام های پشتیبانی</span>
                                            </Link>
                                        </li>
                                        <li className="nk-menu-item">
                                            <Link to="/mytransactions/" className="nk-menu-link">
                                                <span className="nk-menu-text">پرداختهای من</span>
                                            </Link>
                                        </li>
                                        <li className="nk-menu-item">
                                            <Link to="/myorders/" className="nk-menu-link">
                                                <span className="nk-menu-text">سفارشات من</span>
                                            </Link>
                                        </li>
                                        <li className="nk-menu-item">
                                            <Link to="/inquiry/stuff/" className="nk-menu-link">
                                                <span className="nk-menu-text">استعلام کالا/خدمات</span>
                                            </Link>
                                        </li>
                                        <li className="nk-menu-item">
                                            <Link to="/csr/" className="nk-menu-link">
                                                <span className="nk-menu-text">تولید کلید و گواهی</span>
                                            </Link>
                                        </li>
                                        <li className="nk-menu-item">
                                            <Link to="/inquiry/economiccode/" className="nk-menu-link">
                                                <span className="nk-menu-text">استعلام شناسه ملی</span>
                                            </Link>
                                        </li>
                                    </ul>
                                </li>}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}